import { render, staticRenderFns } from "./AdditionalDashboards.vue?vue&type=template&id=55dde102"
import script from "./AdditionalDashboards.vue?vue&type=script&lang=js"
export * from "./AdditionalDashboards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports